import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DropDownFetchCount from "./DropDownFetchCount";
import AxisSpinner from "./AxisSpinner";
import Table from "react-bootstrap/Table";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { ButtonNewCert } from "./ShiftShiftButtonActionsElements";
import CertificationCreateUpdateModal from "../modals/CertificationCreateUpdateModal";
import { SuccessCheckMark } from "./AxisCheckMark";
import { ALL_ROLE, formatRole } from "./CertCreation";

export const CertificatesTable = () => {
  const { authAxios } = useAuth();
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [offset, setOffset] = useState(0);
  const [fetchCount, setFetchCount] = useState(50);
  const [loading, setLoading] = useState(false);
  const [sortKey, setSortKey] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [selectedCert, setSelectedCert] = useState(null);
  const [showCertCreation, setShowCertCreation] = useState(false);

  useEffect(() => {
    paginate();
  }, [offset, sortKey, sortDirection, fetchCount]);

  const paginate = async () => {
    try {
      setLoading(true);

      const pageSettings = {
        direction: sortDirection,
        key: sortKey,
        page: offset,
        elementPerPage: fetchCount,
      };
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const page = await authAxios().post(
        "/api/backoffice/certs/certs_paging",
        pageSettings,
        config,
      );
      setLoading(false);

      if (page.data.content.length === 0) {
        console.log("empty api call");
        setDataSource([]);
        setTotal(0);
        return;
      }

      setDataSource(page.data.content);
      setTotal(page.data.totalElements);
      var length = Math.ceil(page.data.totalElements / fetchCount);
      setTotalPages(length);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
      setDataSource([]);
      setTotal(0);
    }
  };

  const handleSetSortKey = (key) => {
    if (sortKey === key) {
      if (sortDirection === "asc") {
        setSortDirection("dsc");
      } else {
        setSortDirection("asc");
      }
      return;
    }
    setSortKey(key);
  };

  const tableHeading = (key, name) => {
    if (key === sortKey) {
      return sortDirection === "dsc" ? name + " ↓" : name + " ↑";
    }
    return name;
  };

  const getRenewal = (renewal) => {
    if (renewal == null || renewal === undefined) return;

    const years = renewal / 365;
    if (years == 1) return years + " Year";

    return years + " Years";
  };

  const getRoles = (roles) => {
    if (roles == null || roles === undefined || roles.length === 0) return;
    if (roles.includes(ALL_ROLE)) return formatRole(ALL_ROLE);
    return roles.map(formatRole).join(", ");
  };

  const getEmailNotificationType = (emailTemplate) => {
    return emailTemplate === "FACE_TO_FACE" ? "Face to face" : "E-learning";
  };

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;

    return (
      <Fragment>
        <Table striped bordered hover>
          <thead>
            <tr style={{ cursor: "pointer" }}>
              <th onClick={() => handleSetSortKey("name")}>
                {tableHeading("name", "Name")}
              </th>
              <th onClick={() => handleSetSortKey("type")}>
                {tableHeading("type", "Type")}
              </th>
              <th onClick={() => handleSetSortKey("defaultLifeTimeDays")}>
                {tableHeading("defaultLifeTimeDays", "Renewal")}
              </th>
              <th onClick={() => handleSetSortKey("is_mandatory")}>
                {tableHeading("is_mandatory", "Mandatory")}
              </th>
              <th>Email Notification Type</th>
              <th>Roles</th>
            </tr>
          </thead>
          <tbody>
            {dataSource.map((cert) => (
              <tr
                key={cert?.id}
                onClick={() => {
                  setSelectedCert(cert);
                  setShowCertCreation(true);
                }}
              >
                <td>{cert?.name}</td>
                <td>{cert?.type}</td>
                <td>{getRenewal(cert?.defaultLifeTimeDays)}</td>
                <td>{cert?.mandatory ? SuccessCheckMark() : null}</td>
                <td>{getEmailNotificationType(cert?.emailTemplate)}</td>
                <td>{getRoles(cert?.medicalRoles)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div>
          Page {offset + 1} of {totalPages}, showing {dataSource.length} record
          {dataSource.length === 1 ? "" : "s"} out of {total}
          <div>
            <PaginationControl
              page={offset + 1}
              between={3}
              total={total}
              limit={fetchCount}
              changePage={(page) => {
                setOffset(page - 1);
              }}
              ellipsis={1}
            />
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Container fluid className={"m-0 p-0"}>
        <Row xs={"auto"} className={"align-items-center g-3"}>
          <Col xs={"auto"}>
            <Row xs={"auto"} className={"justify-content-start"}>
              <Col xs={"auto"}>
                <DropDownFetchCount
                  onSelected={setFetchCount}
                  defaultSelection={fetchCount}
                />
              </Col>
              <Col xs={"auto"}>
                <ButtonNewCert
                  action={() => {
                    setSelectedCert(null);
                    setShowCertCreation(true);
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <br />

      {SpinnerOrData(loading)}

      <CertificationCreateUpdateModal
        visible={showCertCreation}
        close={() => setShowCertCreation(false)}
        certList={dataSource}
        cert={selectedCert}
        updateCert={() => {
          paginate();
        }}
      />
    </Fragment>
  );
};
